import { createSelector } from '@ngrx/store';
import { surveyCreationFeature } from '../survey-creation.feature';

const { selectAudience } = surveyCreationFeature;

export const selectSurveyId = createSelector(
  selectAudience,
  ({ surveyId }) => surveyId,
);

export const selectSurvey = createSelector(
  selectAudience,
  ({ survey }) => survey,
);

export const selectMetadataForm = createSelector(
  selectAudience,
  ({ metadata }) => metadata,
);

export const selectQualificationsForm = createSelector(
  selectAudience,
  ({ qualifications }) => qualifications,
);

export const selectQuotasForm = createSelector(
  selectAudience,
  ({ quotas }) => quotas,
);

export const selectSurveyFormState = createSelector(
  selectMetadataForm,
  selectQualificationsForm,
  selectQuotasForm,
  (metadata, qualifications, quotas) => ({ metadata, qualifications, quotas }),
);

export const selectError = createSelector(selectAudience, ({ error }) => error);

export const selectLocationFileUpload = createSelector(
  selectAudience,
  ({ locationFileUpload }) => locationFileUpload,
);
